// Data Sources API slice
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from './store';

export interface DataRecord {
  date: string;
  search_channel: string;
  country: string;
  total_searches: number;
  monetized_searches: number;
  clicks: number;
  revenue: number;
  affiliateNetworkId: string;
  redtrackAffiliateNetworkId: string;
  isEstimated?: boolean;
  tq?: number;
}

export interface DataSourceInfo {
  name: string;
  affiliateNetworkId: string;
  redtrackNetworkId?: string;
  voluumNetworkId?: string;
}

export interface DataSourceResult {
  dataSource: DataSourceInfo;
  records: DataRecord[];
  recordCount: number;
  dateRange: {
    startDate: string;
    endDate: string;
  };
}

export interface GetDataSourceDataParams {
  id: string;
  startDate?: string;
  endDate?: string;
}

const baseUrl = process.env.NEXT_PUBLIC_API_ENDPOINT ?? 'http://localhost:3310';

export const dataSourcesApi = createApi({
  reducerPath: 'dataSourcesApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['DataSources', 'DataSourceData'],
  endpoints: (builder) => ({
    getDataSources: builder.query<DataSourceInfo[], void>({
      query: () => 'data-sources',
      providesTags: ['DataSources'],
    }),
    getDataSourceData: builder.query<DataSourceResult, GetDataSourceDataParams>({
      query: ({ id, startDate, endDate }) => ({
        url: `data-sources/${id}`,
        params: {
          ...(startDate && { startDate }),
          ...(endDate && { endDate }),
        },
      }),
      providesTags: (result, error, { id }) => [{ type: 'DataSourceData', id }],
    }),
  }),
});

export const {
  useGetDataSourcesQuery,
  useGetDataSourceDataQuery,
} = dataSourcesApi;
